"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _localization = require("@lt/localization");
var _utils = require("../assets/utils");
var _constants = require("../assets/constants");
var _Bubble = _interopRequireDefault(require("../../Bubble"));
var _CancellationPolicyStageDescription = _interopRequireDefault(require("./CancellationPolicyStageDescription"));
var _CancellationPolicyStageDate = _interopRequireDefault(require("./CancellationPolicyStageDate"));
var _CancellationPolicyStageTooltip = _interopRequireDefault(require("./CancellationPolicyStageTooltip"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var CancellationPolicyStage = function CancellationPolicyStage(props) {
  var color = props.color,
    className = props.className,
    price = props.refund_amount,
    interval = props.interval,
    _props$firstWidest = props.firstWidest,
    firstWidest = _props$firstWidest === void 0 ? false : _props$firstWidest,
    _props$last = props.last,
    last = _props$last === void 0 ? false : _props$last,
    _props$secondWidest = props.secondWidest,
    secondWidest = _props$secondWidest === void 0 ? false : _props$secondWidest,
    returnType = props.return_type,
    _props$progress = props.progress,
    progress = _props$progress === void 0 ? 0 : _props$progress,
    _props$mobile = props.mobile,
    mobile = _props$mobile === void 0 ? false : _props$mobile,
    _props$hasNowDate = props.hasNowDate,
    hasNowDate = _props$hasNowDate === void 0 ? false : _props$hasNowDate,
    cancellationDateISO = props.cancellationDateISO,
    cancelled = props.cancelled,
    _props$firstStage = props.firstStage,
    firstStage = _props$firstStage === void 0 ? false : _props$firstStage,
    isHotelOnly = props.isHotelOnly;
  var fullReturn = (0, _utils.isFullReturn)(returnType);
  var hasProgress = progress > 0;
  var isMobileShownStage = firstWidest || secondWidest || last;
  var returnHeader = (0, _utils.getReturnHeader)(price, fullReturn);
  var returnText = (0, _utils.getReturnText)(price, interval, fullReturn, isHotelOnly);
  var renderDescription = (0, _react.useCallback)(function () {
    return /*#__PURE__*/_react["default"].createElement(_CancellationPolicyStageDescription["default"], {
      title: returnHeader,
      interval: interval,
      description: returnText,
      price: price
    });
  }, [interval]);
  var popupText = cancellationDateISO ? (0, _utils.getCancelledText)(cancellationDateISO) : _localization.i18n.t('cancellationPolicy.today');

  // @TODO Когда будет общий универсальный tooltip компонент это переделать
  var todayPopupComponent = /*#__PURE__*/_react["default"].createElement(TodayPopupPointer, {
    progress: progress,
    firstStage: firstStage,
    last: last
  }, /*#__PURE__*/_react["default"].createElement(_CancellationPolicyStageTooltip["default"], {
    text: popupText,
    isFullProgress: progress >= 80
  }));
  var isEmptyPrice = mobile && !isMobileShownStage;
  var priceText = isEmptyPrice ? '' : (0, _utils.getPriceText)(price, fullReturn);
  var hasLeftMargin = function () {
    if (cancelled) {
      if (progress !== 100) {
        return true;
      }
      return false;
    }
    return true;
  }();
  var isColorMuted = cancelled && progress === 100;
  var StagePriceWrapper = /*#__PURE__*/_react["default"].createElement(StyledStagePriceWrapper, {
    isColorMuted: isColorMuted,
    isMobile: mobile
  }, /*#__PURE__*/_react["default"].createElement(StyledStagePrice, null, priceText));
  return /*#__PURE__*/_react["default"].createElement(StyledStage, {
    className: className,
    firstWidest: firstWidest,
    second: secondWidest,
    last: last,
    mobile: mobile,
    hasLeftMargin: hasLeftMargin
  }, mobile ? StagePriceWrapper : /*#__PURE__*/_react["default"].createElement(BubbleContainer, {
    last: last,
    color: color
  }, /*#__PURE__*/_react["default"].createElement(StyledBubble, {
    renderExtras: renderDescription
  }, StagePriceWrapper)), /*#__PURE__*/_react["default"].createElement(_CancellationPolicyStageDate["default"], {
    dateISO: interval.startDateISO,
    firstStage: firstStage,
    firstWidest: firstWidest,
    secondWidest: secondWidest,
    last: last,
    mobile: mobile,
    empty: mobile && !isMobileShownStage,
    isHotelOnly: isHotelOnly
  }), hasProgress ? /*#__PURE__*/_react["default"].createElement(StyledProgress, {
    cancelled: cancelled,
    progress: progress,
    firstWidest: firstWidest,
    fullReturn: fullReturn,
    last: last
  }) : null, hasNowDate ? todayPopupComponent : null);
};
var TodayPopupPointer = _styledComponents["default"].div.withConfig({
  displayName: "CancellationPolicyStage__TodayPopupPointer",
  componentId: "sc-l7d525-0"
})(["position:absolute;background-color:transparent;top:0;height:24px;width:1px;", ""], function (_ref) {
  var progress = _ref.progress;
  return "right: ".concat(progress, "%;");
});
var StyledStage = _styledComponents["default"].div.withConfig({
  displayName: "CancellationPolicyStage__StyledStage",
  componentId: "sc-l7d525-1"
})(["flex-grow:1;cursor:default;position:relative;", " ", " ", " ", ""], function (_ref2) {
  var hasLeftMargin = _ref2.hasLeftMargin;
  return hasLeftMargin && "margin-left: 1px;";
}, function (_ref3) {
  var last = _ref3.last,
    mobile = _ref3.mobile,
    firstWidest = _ref3.firstWidest;
  return last && mobile && !firstWidest && "max-width: 42px;";
}, function (_ref4) {
  var firstWidest = _ref4.firstWidest,
    mobile = _ref4.mobile;
  return firstWidest && "min-width: ".concat(mobile ? _constants.FIRST_STAGE_WIDTH_MOBILE : _constants.FIRST_STAGE_WIDTH, "px;");
}, function (_ref5) {
  var second = _ref5.second,
    mobile = _ref5.mobile;
  return second && mobile && "min-width: ".concat(_constants.SECOND_STAGE_WIDTH, "px;");
});
var StyledProgress = _styledComponents["default"].div.withConfig({
  displayName: "CancellationPolicyStage__StyledProgress",
  componentId: "sc-l7d525-2"
})(["position:absolute;right:0;top:0;bottom:0;height:24px;", " ", " ", " ", " ", ""], function (_ref6) {
  var cancelled = _ref6.cancelled;
  return "background-color: ".concat(cancelled ? '#fff' : '#F8F8F8', ";");
}, function (_ref7) {
  var fullReturn = _ref7.fullReturn;
  return fullReturn && "background-color: rgb(241, 247, 210);";
}, function (_ref8) {
  var cancelled = _ref8.cancelled,
    last = _ref8.last,
    firstWidest = _ref8.firstWidest,
    progress = _ref8.progress;
  return cancelled && "\n      border-top: solid 1px #E6E9EE;\n      border-bottom: solid 1px #E6E9EE;\n      ".concat(last ? "border-right: solid 1px #E6E9EE;" : '', "\n      ").concat(firstWidest && progress === 100 ? "border-left: solid 1px #E6E9EE;" : '', "\n  ");
}, function (_ref9) {
  var last = _ref9.last;
  return last && "background-color: #F5F3F2;";
}, function (_ref10) {
  var progress = _ref10.progress;
  return "width: ".concat(progress, "%;");
});
var BubbleContainer = _styledComponents["default"].div.withConfig({
  displayName: "CancellationPolicyStage__BubbleContainer",
  componentId: "sc-l7d525-3"
})(["", " ", ""], function (_ref11) {
  var color = _ref11.color;
  return color && "\n    background-color: ".concat(color, ";\n  ");
}, function (_ref12) {
  var last = _ref12.last;
  return last && "background-color: #F8F8F8;";
});
var StyledBubble = (0, _styledComponents["default"])(_Bubble["default"]).withConfig({
  displayName: "CancellationPolicyStage__StyledBubble",
  componentId: "sc-l7d525-4"
})(["justify-content:center;background:repeating-linear-gradient( -60deg,#c2c5cc 0,#c2c5cc 1px,transparent 1px,transparent 3px );"]);
var StyledStagePrice = _styledComponents["default"].div.withConfig({
  displayName: "CancellationPolicyStage__StyledStagePrice",
  componentId: "sc-l7d525-5"
})(["height:100%;width:100%;z-index:100;display:flex;align-items:center;justify-content:center;"]);
var StyledStagePriceWrapper = _styledComponents["default"].div.withConfig({
  displayName: "CancellationPolicyStage__StyledStagePriceWrapper",
  componentId: "sc-l7d525-6"
})(["", ";font-size:14px;line-height:16px;color:", ";display:flex;align-items:center;justify-content:center;height:24px;width:100%;"], function (_ref13) {
  var isMobile = _ref13.isMobile;
  return isMobile && (0, _styledComponents.css)(["background:var(--grey3)"]);
}, function (_ref14) {
  var theme = _ref14.theme,
    isColorMuted = _ref14.isColorMuted;
  return isColorMuted ? '#E6E9EE' : theme.colors.blackLight;
});
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(CancellationPolicyStage);